export default {
      id: "icon-lexikon-usage",
      viewBox: "0 0 30 30",
      url: "/" + "sprite.svg#icon-lexikon",
      toString: function () {
        return this.url;
      }
    }